import React from 'react';

import autoBind from 'react-autobind';
import { If, Then } from 'react-if'
import Switch, { Case } from 'react-switch-case';
import DeckGL from "deck.gl";
import {WebMercatorViewport, FlyToInterpolator} from 'deck.gl';
import {GeoJsonLayer, IconLayer, TextLayer, ScatterplotLayer} from 'deck.gl'
import { _MapContext as MapContext, StaticMap, NavigationControl, Marker } from "react-map-gl";


// import other components within the same project here
import Config from "composer/Config.jsx";

import Localization from "composer/Localization.jsx"

import RootPage from "composer/pages/RootPage.jsx"
import HotspotListView from "composer/views/hotspot/HotspotListView.jsx"
import HotspotViewerBar from "composer/views/hotspot/HotspotViewerBar.jsx"
import HotspotDetailView from "composer/views/hotspot/HotspotDetailView.jsx"

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';

import { Grid, SvgIcon } from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';

import MarkerWithLabel from "react-google-maps/lib/components/addons/MarkerWithLabel"
import columnLayer from '@deck.gl/layers/dist/es5/column-layer/column-layer';
import view from '@deck.gl/core/dist/es5/views/view';

const VIEW_HOTSPOT_LIST = 0;
const VIEW_HOTSPOT_DETAIL = 1;

const DEFAULT_MAP_ZOOM = 15;

class HotspotViewerPage extends React.Component {


  static VIEW_HOTSPOT_LIST() {
    return VIEW_HOTSPOT_LIST;
  }

  static VIEW_HOTSPOT_DETAIL() {
    return VIEW_HOTSPOT_DETAIL;
  }

  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      localeColor: this.props.theme.palette.primary.main,
      hotspotList: [],
      localeCenter: { lat: parseFloat(this.props.currentLocale.mid_lat), lng: parseFloat(this.props.currentLocale.mid_lon) },
      localeBound: {
        ul_lat: parseFloat(this.props.currentLocale.ul_lat),
        ul_lon: parseFloat(this.props.currentLocale.ul_lon),
        br_lat: parseFloat(this.props.currentLocale.br_lat),
        br_lon: parseFloat(this.props.currentLocale.br_lon),
      },
      new_hotspot: true,
      zoom: DEFAULT_MAP_ZOOM,
      currentView: VIEW_HOTSPOT_LIST,
      currentHotspot: {},
      hotspotCenter: null,
      map: {
        zoom: 0,
        center: {
          lat: 0,
          lon: 0
        },
        bounds:{
          ul:{
            lat: 0,
            lon: 0
          },
          br:{
            lat: 0,
            lon: 0
          }
        },
        style: Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon,
        _style: "cartoon",
        lang: "zh"
      },
      viewState:{
        latitude: 37.7751,
        longitude: -122.4193,
        zoom: 11,
        bearing: 0,
        pitch: 0,
        width: 500,
        height: 500
      },
      hotspotID: -1,
      width: 0,
      height: 0,
      newHotspotID: -1,
      flyContainer: new FlyToInterpolator({speed: 2}),
      marker_data: {
        show: false,
        out_screen: false,
        lat: 0,
        lon: 0,
        meta: null,
        index: -1
      }
    };
    autoBind(this);
    this.getHotspotByLocaleID(this.props.currentLocale.id);
    this.state.hotspotCenter = this.state.localeCenter;
    this.state.viewState = {
      longitude: this.state.currentView === VIEW_HOTSPOT_LIST? this.state.localeCenter.lng : this.state.hotspotCenter.lng,
      latitude: this.state.currentView === VIEW_HOTSPOT_LIST? this.state.localeCenter.lat : this.state.hotspotCenter.lat,
      zoom: this.state.zoom,
      bearing: 0,
      pitch: 0,
      width: 500,
      height: 500,
      maxZoom: 17,
      minZoom: 3
    };
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    this.props.root.setTitle("")
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    let boundingRect = this.refs.hotspotViewerBar.refs.div.getBoundingClientRect();
    console.log(boundingRect);
    let height = window.innerHeight - (boundingRect.y + window.scrollY + boundingRect.height);

    if(height <= 0){
      height = window.innerHeight - (64 + window.scrollY + 56.5);
    }

    this.setState({
      width: window.innerWidth,
      height: height,
    });
    this.state.width = window.innerWidth;
    this.state.height = height;
  }

  changeView(view) {
    this.setState({ currentView: view });
    this.state.currentView = view;

    if (this.state.currentView == VIEW_HOTSPOT_LIST) {
      this.setState({
        //currentHotspot: {},
        zoom: DEFAULT_MAP_ZOOM,
      });
      //this.state.currentHotspot = {};
      this.state.zoom = DEFAULT_MAP_ZOOM;
      this.currentHotspot = null;
    }
    this.props.root.setTitle("")
  }

  getHotspotByLocaleID(localeID) {
    this.state.hotspotList = [];
    let requestObj = {
      table: "hotspot",
      filter: {
        epack_id: localeID
      },
      order_by: "name",
      order_mode: "ASC",
    };
    this.props.root.refs.API.request("get_list", requestObj, this.getHotspotOK, this.getHotspotFail);
  }

  getHotspotOK(res) {
    this.setState({hotspotList: res.body.result});
    this.state.hotspotList = res.body.result;

    for (let i = 0; i < this.state.hotspotList.length; i++) {
      if (this.state.hotspotList[i].id == this.state.hotspotID) {
        this.setState({ currentHotspot: this.state.hotspotList[i] });
        this.state.currentHotspot = this.state.hotspotList[i];
      }

      if (this.state.hotspotList[i].id == this.state.newHotspotID) {
        this.setState({ newHotspotID: -1 });
        this.state.newHotspotID = -1;

        this.handleHotspotClicked(this.state.hotspotList[i]);
      }
    }
  }

  getHotspotFail(err) {
    console.log("get hotspot from server failed");
  }

  addHotspot() {
    //check if hotspot number is more than max 
    var max_len = this.props.root.refs.userDataProfile.state.userInfo.role == 2?Config.MAX_HOTSPOT_LEN().PREMIUM:Config.MAX_HOTSPOT_LEN().NORMAL;
    if(this.state.hotspotList.length >= max_len){
      // pop up error message
      this.props.root.addNotification(Localization.strings.EXCEED_MAX_HOTSPOT, false);
    }else{
      console.log('on add hotspot clicked');
      let defaultHotspotColor = this.props.theme.palette.primary.main;
      let requestObj = {
        table: "hotspot",
        row: {
          name: Localization.strings.NEW_HOTSPOT,
          epack_id: this.props.currentLocale.id,
          color: parseInt(defaultHotspotColor.substring(1), 16),
          radius: 30
        }
      };
      this.props.root.refs.API.request("insert", requestObj, this.addHotspotOK, this.addHotspotFail);
    }
  }

  addHotspotOK(res) {
    let id = res.body['result'];
    this.setState({ 
      newHotspotID: id,
      new_hotspot: true
    });
    this.state.newHotspotID = id;
    this.state.new_hotspot = true;

    this.getHotspotByLocaleID(this.props.currentLocale.id);

    var requestObj = {epack_id: this.props.currentLocale.id};
    this.props.root.refs.API.request("touch_epack", requestObj);
  }

  addHotspotFail(err) {
    console.log("add hotspot fail");
  }

  handleHotspotClicked(hotspot, changeHistory=true) {
    let zoom = this.state.zoom;
    if (this.state.map != null) {
      zoom = this.state.map.zoom;
    }
    this.setState({ currentHotspot: hotspot });
    this.state.currentHotspot = hotspot;
    this.setState({ hotspotID: hotspot.id });
    this.state.hotspotID = hotspot.id;
    let center = this.state.localeCenter;
    if (hotspot['lat'] != "0" && hotspot['lon'] != "0") {
      center = {lat: parseFloat(hotspot['lat']), lng: parseFloat(hotspot['lon']) };
      this.setState({
        marker_data:{
          ...this.state.marker_data,
          show: true,
          lat: parseFloat(hotspot.lat),
          lon: parseFloat(hotspot.lon)
        },
        new_hotspot: false
      });
    }else{
      this.setHotspotPosition();
      this.setState({
        marker_data:{
          ...this.state.marker_data,
          show: true,
          lat: parseFloat(center.lat),
          lon: parseFloat(center.lng)
        }
      });
    }

    //todo: change viewstate too
    this.mapPanTo(center);

    this.changeView(VIEW_HOTSPOT_DETAIL);
    if (changeHistory) {
      this.props.root.pushHistory("hotspot/detail");
    }
  }

  deleteHotspotClicked(id) {
    this.setState({ hotspotID: id });
    this.state.hotspotID = id;
    let dialogText = {
      title: Localization.strings.DELETE_HOTSPOT,
      content: Localization.strings.DELETE_REMINDER,
      confirm: Localization.strings.DELETE,
    };
    this.props.root.refs.confirmDialog.show(dialogText, this.deleteHotspotConfirmClicked, this.deleteHotspotCancelClicked);
  }

  deleteHotspotConfirmClicked() {
    if (this.state.hotspotID >= 0) {
      let requestObj = {table: "hotspot", filter: {id: this.state.hotspotID}};
      this.props.root.refs.API.request("delete", requestObj, this.deleteHotspotOK, this.deleteHotspotFail);
    }
    this.setState({ hotspotID: -1 });
    this.state.hotspotID = -1;
  }

  deleteHotspotCancelClicked() {
    this.setState({ hotspotID: -1 });
    this.state.hotspotID = -1;
  }

  deleteHotspotOK(res) {
    this.getHotspotByLocaleID(this.props.currentLocale.id);

    var requestObj = {epack_id: this.props.currentLocale.id};
    this.props.root.refs.API.request("touch_epack", requestObj);
  }

  deleteHotspotFail(err) {
    console.log("delete hotspot fail " + err);
  }

  handleBackButtonClicked() {
    if (this.state.currentView == VIEW_HOTSPOT_LIST) {
      this.props.root.changeStatus(this.props.root.STATUS_VIEW_LOCALE());
    }
    else if (this.state.currentView == VIEW_HOTSPOT_DETAIL) {
      //check empty content

      this.changeView(VIEW_HOTSPOT_LIST);
    }
    let position = {
      lat: this.state.localeCenter.lat,
      lng: this.state.localeCenter.lng
    };
    this.mapPanTo(position, false);

    // update marker data
    this.setState({
      marker_data:{
        ...this.state.marker_data,
        show: false,
        lat: 0,
        lon: 0
      }
    });
    this.state.marker_data = {
      ...this.state.marker_data,
      show: false,
      lat: 0,
      lon: 0
    }
  }

  handleForwardButtonClicked() {
    if (this.state.currentView == VIEW_HOTSPOT_LIST) {
      this.handleHotspotClicked(this.state.currentHotspot, false);
    }
  }

  hotspotMarkerClicked(index) {
    this.handleHotspotClicked(this.state.hotspotList[index]);
  }

  teleport() {
    if (this.state.currentHotspot) {
      let position = {
        lat: parseFloat(this.state.currentHotspot.lat),
        lng: parseFloat(this.state.currentHotspot.lon)
      };
      this.mapPanTo(position);
    }
  }

  mapPanTo(position, to_hotspot = true) {
    this.setState({
      viewState: {
        ...this.state.viewState,
        longitude: position.lng,
        latitude: position.lat,
        zoom: to_hotspot? 17: 15,
        transitionDuration: 1000,
        transitionInterpolator: this.state.flyContainer
      }
    });
  }

  hotspotListEmpty(){
    return this.state.hotspotList.length == 0;
  }

  hotspotEditValidation(){
    let result = {
      flag: 0, //0: ok, 1: prompt, 2: warning
      message: ""
    }

    
    if (this.refs.hotspotDetailView.state.hotspotName == ""){
      result.flag = 2;
      result.message = Localization.strings.HOTSPOT_EMPTY_NAME_REMINDER;
    }else if (this.state.new_hotspot && this.refs.hotspotDetailView.state.contentList.length == 0){
      result.flag = 1;
      result.message = Localization.strings.HOTSPOT_EDIT_REMINDER_1;
    }else if (this.state.new_hotspot){
      result.flag = 1;
      result.message = Localization.strings.HOTSPOT_EDIT_REMINDER_2;
    }else if (this.refs.hotspotDetailView.state.contentList.length == 0){
      result.flag = 1;
      result.message = Localization.strings.EMPTY_TAG_PROMPT;
    }
    return result;
  }

  updateHotspotDetail() {
    this.updateMapState();
    let hotspotDetailViewState = this.refs.hotspotDetailView.state;
    let requestObj = {
      table: "hotspot",
      where_field: "id",
      where_value: this.state.currentHotspot.id,
      row: {
        name: hotspotDetailViewState.hotspotName,
        color: parseInt(hotspotDetailViewState.hotspotColor.substring(1), 16),
        radius: hotspotDetailViewState.hotspotRadius,
        disclose: hotspotDetailViewState.hotspotVisibility,
        lat: parseFloat(this.state.currentHotspot.lat),
        lon: parseFloat(this.state.currentHotspot.lon)
      }
    };
    this.props.root.refs.API.request("update", requestObj, this.updateHotspotDetailOK, this.updateHotspotDetailFail);
  }

  updateHotspotDetailOK(res) {
    this.getHotspotByLocaleID(this.props.currentLocale.id);
    this.props.root.addNotification(Localization.strings.UPDATED, true);

    var requestObj = {epack_id: this.props.currentLocale.id};
    this.props.root.refs.API.request("touch_epack", requestObj);
  }

  updateHotspotDetailFail(err) {
    console.log("update hotspot detail fail " + err);
    this.props.root.addNotification(Localization.strings.UPDATE_FAILED, true);
  }

  addContentClicked() {
    this.refs.hotspotDetailView.handleAddContentClicked();
  }

  onMapMounted = (map) => {
    this.state.map = map;
  }

  onMarkerMounted = (marker) => {
    this.state.currentHotspotMarker = marker;
  }

  hotspotMarkerDragEnd() {
    let position = {
      lat: this.state.marker_data.lat,
      lng: this.state.marker_data.lon
    }
    var bound = {
      ul:{
        lat: Math.min(this.state.map.bounds.ul.lat, this.state.localeBound.ul_lat),
        lon: Math.max(this.state.map.bounds.ul.lon, this.state.localeBound.ul_lon)
      },
      br:{
        lat: Math.max(this.state.map.bounds.br.lat, this.state.localeBound.br_lat),
        lon: Math.min(this.state.map.bounds.br.lon, this.state.localeBound.br_lon)
      }
    };
    position.lat = Math.max(bound.br.lat, Math.min(position.lat, bound.ul.lat));
    position.lng = Math.max(bound.ul.lon, Math.min(position.lng, bound.br.lon));

    this.updateMapState();

    this.setState({
      lat: position.lat,
      lon: position.lng,
    });
    this.state.currentHotspot.lat = position.lat;
    this.state.currentHotspot.lon = position.lng;

    // update marker data
    this.setState({
      marker_data:{
        ...this.state.marker_data,
        lat: this.state.currentHotspot.lat,
        lon: this.state.currentHotspot.lon
      }
    });
    this.state.marker_data = {
      ...this.state.marker_data,
      lat: this.state.currentHotspot.lat,
      lon: this.state.currentHotspot.lon
    }
  }

  updateHotspotColor (color) {
    this.updateMapState();

    let hotspot = this.state.currentHotspot;
    hotspot.color = parseInt(color.hex.substring(1), 16);
    this.setState({ currentHotspot: hotspot });
    this.state.currentHotspot = hotspot;
  }

  updateHotspotRadius(radius) {
    this.updateMapState();

    let hotspot = this.state.currentHotspot;
    hotspot.radius = radius;
    this.setState({ currentHotspot: hotspot });
    this.state.currentHotspot = hotspot;
  }

  setHotspotPosition() {
    let requestObj = {
      table: "hotspot",
      where_field: "id",
      where_value: this.state.currentHotspot.id,
      row: {
        lat: this.state.localeCenter.lat,
        lon: this.state.localeCenter.lng,
      }
    };
    this.props.root.refs.API.request("update", requestObj, this.updateHotspotDetailOK, this.updateHotspotDetailFail);

    // show marker
    this.setState({
      marker_data:{
        show: true,
        lat: this.state.localeCenter.lat,
        lon: this.state.localeCenter.lng,
        meta: null,
        index: -1
      }
    });
  }

  updateMapState() {
    let zoom = this.state.map.zoom;
    let center = {
      lat: this.state.map.center.lat,
      lng: this.state.map.center.lon
    };

    this.setState({
      zoom: zoom,
      hotspotCenter: center,
    });
    this.state.zoom = zoom;
    this.state.hotspotCenter = center;
  }

  genBoxData(){
    if (!this.props.currentLocale){
      return;
    }
    var boxData = []
    boxData.push({
      'type': 'Feature',
      'color': parseInt(this.props.currentLocale.color).toString(16),
      'geometry': {
        'type': 'Polygon',
        'coordinates': [[
          [parseFloat(this.props.currentLocale.ul_lon), parseFloat(this.props.currentLocale.ul_lat)],
          [parseFloat(this.props.currentLocale.ul_lon), parseFloat(this.props.currentLocale.br_lat)],
          [parseFloat(this.props.currentLocale.br_lon), parseFloat(this.props.currentLocale.br_lat)],
          [parseFloat(this.props.currentLocale.br_lon), parseFloat(this.props.currentLocale.ul_lat)],
          [parseFloat(this.props.currentLocale.ul_lon), parseFloat(this.props.currentLocale.ul_lat)]
        ]]
      }
    });

    var boxLayers = new GeoJsonLayer({
        id: 'geojson-layer',
        data: boxData,
        lineWidthScale: 4,
        opacity: 0.4,
        filled: true,
        stroked: true,
        lineWidth: 2,
        lineWidthMinPixels: 2,
        wireframe: true,
        getLineColor: f => {
          var hex = f.color;
          while(hex.length != 6){
            hex = '0' + hex;
          }
          // convert to RGB
          return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0];
        },
        getFillColor: f => {
          var hex = f.color;
          while(hex.length != 6){
            hex = '0' + hex;
          }
          hex = hex + '00';
          // convert to RGB
          return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0, 0];
        },
        pickable: true,
      });

      return boxLayers
  }

  genIconLayer(){
    var iconData = []
    for(var i = 0; i<this.props.parent.state.localeListInMap.length; i++){
      iconData.push({
        'color': parseInt(this.props.parent.state.localeListInMap[i].color).toString(16),
        'coordinates': [(parseFloat(this.props.parent.state.localeListInMap[i].ul_lon) + parseFloat(this.props.parent.state.localeListInMap[i].br_lon))/2, (parseFloat(this.props.parent.state.localeListInMap[i].ul_lat) + parseFloat(this.props.parent.state.localeListInMap[i].br_lat))/2],
        'meta': this.props.parent.state.localeListInMap[i]
      });
    }

    const ICON_MAPPING = {
      marker: {
        x: 0,
        y: 0,
        width: 128,
        height: 128,
        anchorY: 128,
        mask: true
      }
    };

    var iconLayers = new IconLayer({
      id: 'icon-layer',
      data: iconData,
      pickable: true,
      autoHighlight: false,
      iconAtlas: 'https://raw.githubusercontent.com/visgl/deck.gl-data/master/website/icon-atlas.png',
      iconMapping: ICON_MAPPING,
      getIcon: d => 'marker',

      sizeScale: 10,
      getPosition: d => d.coordinates,
      getSize: d => 5,
      getColor: f => {
        var hex = f.color;
        while(hex.length != 6){
          hex = '0' + hex;
        }
        // convert to RGB
        return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0, 0];
      },
    });

    return iconLayers;
  }

  genTextLayer(){
    var textData = []
    var charSet = ''

    // todo: do not show text label when adding new hotspot

    for(var i = 0; i<this.state.hotspotList.length; i++){
      if(this.state.currentView === VIEW_HOTSPOT_LIST){
        textData.push({
          'color': parseInt(this.state.hotspotList[i].color).toString(16),
          'name': this.state.hotspotList[i].name,
          'coordinates': [parseFloat(this.state.hotspotList[i].lon), parseFloat(this.state.hotspotList[i].lat)]
        });
      }else{
        if(this.state.hotspotList[i].id == this.state.currentHotspot.id){
          // textData.push({
          //   'color': parseInt(this.state.hotspotList[i].color).toString(16),
          //   'name': this.state.hotspotList[i].name,
          //   'coordinates': [parseFloat(this.state.hotspotList[i].lon), parseFloat(this.state.hotspotList[i].lat)]
          // });
        }
      }

      charSet = charSet + this.state.hotspotList[i].name;
    }
    var textLayers = new TextLayer({
      id: 'TextLayer',
      data: textData,

      /* props from TextLayer class */
      autoHighlight: false,
      background: true,
      backgroundColor: [255, 255, 255, 150], //cannot use alpha channel
      backgroundPadding: [5, 5, 5, 5],
      characterSet: charSet.split(''),
      getAlignmentBaseline: 'top',
      getAngle: 0,
      getColor: f => {
        var hex = f.color;
        while(hex.length != 6){
          hex = '0' + hex;
        }
        // convert to RGB
        return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0, 0];
      },
      getPosition: d => d.coordinates,
      getSize: 12,
      getText: d => d.name,
      getTextAnchor: 'middle',
      sizeScale: 1,
      pickable: true,
    });

    return textLayers;
  }

  genCircleLayer(){
    var circleData = []
    for(var i = 0; i<this.state.hotspotList.length; i++){
      if(this.state.currentView === VIEW_HOTSPOT_LIST){
        circleData.push({
          'color': parseInt(this.state.hotspotList[i].color).toString(16),
          'radius': parseInt(this.state.hotspotList[i].radius),
          'centroid': [parseFloat(this.state.hotspotList[i].lon), parseFloat(this.state.hotspotList[i].lat)]
        });
      }else{
        if(this.state.hotspotList[i].id == this.state.currentHotspot.id){
          circleData.push({
            'color': parseInt(this.state.hotspotList[i].color).toString(16),
            'radius': parseInt(this.state.hotspotList[i].radius),
            'centroid': [parseFloat(this.state.hotspotList[i].lon), parseFloat(this.state.hotspotList[i].lat)]
          });
        }
      }
    }

    var circleLayers = new ScatterplotLayer({
      id: 'ColumnLayer',
      data: circleData,
      extruded: false,
      getLineWidth: 20,
      diskResolution: 30,
      elevationScale: 100,
      getElevation: 0.4 * 50,
      getLineWidth: f => {
        var radius = f.radius;
        return Math.ceil(radius/11);
      },
      getLineColor: f => {
        var hex = f.color;
        while(hex.length != 6){
          hex = '0' + hex;
        }
        // convert to RGB
        return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0];
      },
      getFillColor: f => {
        var hex = f.color;
        while(hex.length != 6){
          hex = '0' + hex;
        }
        hex = hex + '1f';
        // convert to RGB
        return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0, 0];
      },
      getPosition: d => d.centroid,
      getRadius: d => d.radius,
      radiusMinPixels: 1,
      stroked: true,
      pickable: true
    });

    return circleLayers;
  }

  render() {
    const initialViewState = {
      longitude: this.state.currentView === VIEW_HOTSPOT_LIST? this.state.localeCenter.lng : this.state.hotspotCenter.lng,
      latitude: this.state.currentView === VIEW_HOTSPOT_LIST? this.state.localeCenter.lat : this.state.hotspotCenter.lat,
      zoom: this.state.zoom
    };

    if(Localization.strings.getLanguage() != this.state.map.lang){
      this.state.map.lang = Localization.strings.getLanguage();
      switch(this.state.map._style){
        case "mono":
          this.setState({
            map:{
              ...this.state.map,
              style: Config.MBOX_STYLE(Localization.strings.getLanguage()).mono,
              _style: "mono"
            }
          });
          this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).mono;
          this.state.map._style = "mono";
          break;
        case "satellite":
          this.setState({
            map:{
              ...this.state.map,
              style: Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite,
              _style: "satellite"
            }
          });
          this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite;
          this.state.map._style = "satellite";
          break;
        case "cartoon":
          this.setState({
            map:{
              ...this.state.map,
              style: Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon,
              _style: "cartoon"
            }
          });
          this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon;
          this.state.map._style = "cartoon";
          break;
      }
    }

    const { viewState, map } = this.state;
    const boxLayers = this.genBoxData();
    const textLayers = this.genTextLayer();
    const circleLayers = this.genCircleLayer();

    return (
      <div>
        <HotspotViewerBar root={this.props.root} parent={this} ref="hotspotViewerBar"/>

        <Grid container>
          <Grid item xs={8} sm={3}>
            <Switch condition={this.state.currentView}>
              <Case value={VIEW_HOTSPOT_LIST}>
                <HotspotListView root={this.props.root} parent={this}/>
              </Case>
              <Case value={VIEW_HOTSPOT_DETAIL}>
                <HotspotDetailView root={this.props.root} parent={this} currentHotspot={this.state.currentHotspot} ref="hotspotDetailView"/>
              </Case>
            </Switch>
          </Grid>
          <Grid item xs={8} sm={9}>
            <div style={{position:"relative"}}>
              <DeckGL
                initialViewState={initialViewState}
                viewState={viewState}
                ContextProvider={MapContext.Provider}
                controller={true} height={this.state.height}
                top="50px" position="relative"
                layers={[boxLayers, circleLayers, textLayers]}
                // onDrag={(stuff =>{
                //   console.log(stuff);
                // })}
                onViewStateChange={(viewState =>{
                  this.setState({
                    viewState: {
                      ...this.state.viewState,
                      zoom: viewState.viewState.zoom,
                      longitude: viewState.viewState.longitude,
                      latitude: viewState.viewState.latitude,
                      transitionDuration: 0,
                      transitionInterpolator: null
                    }
                  });

                  // update boundary only if marker is shown
                  if (this.state.marker_data.show){
                    const viewport = new WebMercatorViewport(viewState.viewState);
                    const ul = viewport.unproject([0, 0]);
                    const br = viewport.unproject([this.state.width, this.state.height], false);
                    // update map's field here (center...)
                    this.state.map.zoom = viewState.viewState.zoom;
                    this.state.map.center.lon = viewState.viewState.longitude;
                    this.state.map.center.lat = viewState.viewState.latitude;
                    this.state.map.bounds.ul.lon = ul[0];
                    this.state.map.bounds.ul.lat = ul[1];
                    this.state.map.bounds.br.lon = br[0];
                    this.state.map.bounds.br.lat = br[1];
                    //check whether the marker is out screen
                    if (this.state.marker_data.lat > this.state.map.bounds.ul.lat || this.state.marker_data.lon < this.state.map.bounds.ul.lon){
                      this.setState({
                        marker_data:{
                          ...this.state.marker_data,
                          out_screen: true
                        }
                      });
                      this.state.marker_data.out_screen = true;
                    }else{
                      this.setState({
                        marker_data:{
                          ...this.state.marker_data,
                          out_screen: false
                        }
                      });
                      this.state.marker_data.out_screen = false;
                    }
                  }
                })}
              >

                  <StaticMap mapStyle={map.style} mapboxApiAccessToken={Config.MBOX_KEY()} attributionControl={false}/>
                  {this.state.marker_data.show && !this.state.marker_data.out_screen && <Marker
                    latitude={this.state.marker_data.lat}
                    longitude={this.state.marker_data.lon}
                    offsetLeft={-12} offsetTop={-23}
                    draggable={true}
                    onDrag={(meta) => {
                      this.setState({
                        marker_data:{
                          ...this.state.marker_data,
                          lat: meta.lngLat[1],
                          lon: meta.lngLat[0]
                        },
                        new_hotspot: false
                      });
                      this.state.marker_data = {
                        ...this.state.marker_data,
                        lat: meta.lngLat[1],
                        lon: meta.lngLat[0]
                      };
                      this.state.new_hotspot = false;
                      this.hotspotMarkerDragEnd();
                    }}
                  >
                    <SvgIcon color='secondary'>
                      <path d={Config.getPinPath()} />
                    </SvgIcon>
                  </Marker>}
                  <ButtonGroup style={{top:10, left:10, position:"relative"}} size="small" variant="contained" color="primary" aria-label="contained primary button group">
                    <Button color={this.state.map._style=="mono"? "secondary":"primary"} onClick={
                      () => {
                        this.setState({
                          map:{
                            ...this.state.map,
                            style: Config.MBOX_STYLE(Localization.strings.getLanguage()).mono,
                            _style: "mono"
                          }
                        });
                        this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).mono;
                        this.state.map._style = "mono";
                      }
                    }>MONO</Button>
                    <Button color={this.state.map._style=="satellite"? "secondary":"primary"} onClick={
                      () => {
                        this.setState({
                          map:{
                            ...this.state.map,
                            style: Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite,
                            _style: "satellite"
                          }
                        });
                        this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite;
                        this.state.map._style = "satellite";
                      }
                    }>SATELLITE</Button>
                    <Button color={this.state.map._style=="cartoon"? "secondary":"primary"} onClick={
                      () => {
                        this.setState({
                          map:{
                            ...this.state.map,
                            style: Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon,
                            _style: "cartoon"
                          }
                        });
                        this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon;
                        this.state.map._style = "cartoon";
                      }
                    }>VECTOR</Button>
                  </ButtonGroup>
                  <NavigationControl style={{top:10, right:10}} showCompass={false}/>
              </DeckGL>
            </div>
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default withTheme(HotspotViewerPage);
